import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { contentCategories, posts } from "@/pages/blog/blogData";
import { categoryBadgeClass } from "@/pages/blog/blogStyles";

export default function CategoryGrid() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Explore por categoria"
          badgeIcon="ri-layout-grid-line"
          title="Explore por categoria"
          description="Navegue pelos temas e encontre conteúdos práticos sobre tecnologia, infraestrutura, desenvolvimento e marketing digital."
        />

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {contentCategories.map((category, index) => {
            const count = posts.filter((post) => post.category === category.slug).length;
            return (
              <Reveal key={category.slug} delay={index * 40}>
                <Link
                  to={`/blog/${category.slug}`}
                  className="group flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
                >
                  <span
                    className={`flex h-12 w-12 items-center justify-center rounded-lg ${categoryBadgeClass(
                      category.accent,
                    )}`}
                  >
                    <i className={`${category.icon} text-2xl`} aria-hidden="true"></i>
                  </span>
                  <span className="mt-4 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {category.name}
                  </span>
                  <span className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {category.description}
                  </span>
                  <span className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-400">
                    <span>{count} {count === 1 ? "artigo" : "artigos"}</span>
                    <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}